module.exports = __webpack_public_path__ + "img/pro_eight_8.f5a8c785.jpg";